import React from 'react'
import { Routes, Route, Link } from "react-router-dom";

import ContactMe from '../pages/contact-me/ContactMe';

function ContactSection() {
  return (
    <section className="flex flex-col md:flex-row pb-8 sm:pb-16 xl:pb-28 md:pb-20 mb-0 sm:mb-5">
        <h2 className="heading-font text-3xl lg:text-4xl font-bold items-center m-auto sm:mb-6 mb-2 w-full xl:w-1/3 md:w-2/5 text-center md:text-left">
        Curious enough to learn more about me?
        </h2>
        <div className="flex-auto w-auto flex items-center py-3">
        <div className="flex-grow h-px bg-gray-400 mx-8 hidden md:block"></div>
        </div>
        <Link to="/contactMe" className="hover:text-white text-sm md:text-xs tracking-widest border border-black px-4 md:px-10 py-2 md:py-4 flex items-center m-auto btn5">
        CONTACT ME
        </Link>
        <Routes>
        <Route path="/contactMe" element={<ContactMe/>} />
        </Routes>
    </section>
  )
}

export default ContactSection